import React from 'react';
import { LibraryAdd, DynamicFeed, Archive, AmpStories, } from "@material-ui/icons";
import { deepOrange } from '@material-ui/core/colors';

const Dashboard = () => {
    return (
        <section id="services">
            <div className="container">
                <div className="row">
                    <div className="col col-md-12 text-center">
                        <h2 className="text-dark">Admin Dashboard</h2>
                        <hr className="my-4 mx-auto" />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <DynamicFeed style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Messages</h3>
                            <a href="/" className="btn btn-outline-danger"><strong>GO</strong></a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <LibraryAdd style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Reiki Articles</h3>
                            <a href="/" className="btn btn-outline-danger"><strong>GO</strong></a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <Archive style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Orders</h3>
                            <a href="/" className="btn btn-outline-danger"><strong>GO</strong></a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <AmpStories style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Invoices</h3>
                            <a href="/" className="btn btn-outline-danger"><strong>GO</strong></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Dashboard

